
const Hero = () => {
  return (
    <section 
      id="inicio" 
      className="relative bg-gradient-to-br from-gray-800 to-gray-900 text-white py-32 px-6"
      style={{
        backgroundImage: 'url(/images/imagem-lampada.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-black opacity-50"></div>
      <div className="container mx-auto text-center relative z-10">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-fade-in">
          Aprenda Elétrica Residencial
        </h1>
        <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto">
          Domine instalações e reparos elétricos residenciais de forma rápida e prática
        </p>
        <a 
          href="#curso" 
          className="inline-block text-gray-900 px-8 py-4 rounded-lg text-lg font-semibold transform hover:scale-105 transition-all duration-300 shadow-xl"
          style={{ backgroundColor: '#E18E37' }}
          onMouseEnter={(e) => e.target.style.backgroundColor = '#C67A2A'}
          onMouseLeave={(e) => e.target.style.backgroundColor = '#E18E37'}
        >
          Comece Agora
        </a>
      </div>
    </section>
  );
};

export default Hero;
